import { FAQPage, WithContext } from "schema-dts";
import { FAQSchemaParams } from "./types";

export const getFAQSchema = ({
    faqData,
    canonicalUrl,
    title
}: FAQSchemaParams): WithContext<FAQPage> | null => {
    const raw = faqData?.mainEntity;
    const list = raw === undefined ? [] : Array.isArray(raw) ? raw : [raw];
    const seen = new Set<string>();

    const mainEntity = list
        .map((item: { name?: unknown; acceptedAnswer?: { text?: unknown } }) => {
            const name = typeof item.name === "string" ? item.name.trim() : "";
            const text =
                typeof item.acceptedAnswer?.text === "string"
                    ? item.acceptedAnswer.text.trim()
                    : "";

            if (!name || !text) return null;

            const key = `${name}::${text}`;
            if (seen.has(key)) return null;
            seen.add(key);

            return {
                "@type": "Question",
                name,
                acceptedAnswer: {
                    "@type": "Answer",
                    text
                }
            };
        })
        .filter(Boolean);

    if (mainEntity.length === 0) return null;

    return {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        inLanguage: faqData?.inLanguage || "ru-RU",
        name: typeof faqData?.name === "string" ? faqData.name : title,
        url: canonicalUrl,
        mainEntity: mainEntity as FAQPage["mainEntity"]
    };
};